<template>
  <div id="header">
<!--    <div id="languageDiv" @mouseover="languageMouseover" @mouseout="languageMouseout" @click.stop="languageDivShow">-->
<!--      <img class="china" src="../../../assets/img/China.png" alt="">-->
<!--      <img :style="languageDivMouseover" class="open" src="../../../assets/img/choose.svg" alt="">-->
<!--    </div>-->
    <div id="adminDiv" @mouseover="adminMouseover" @mouseout="adminMouseout" @click.stop="adminDivShow">
      <img class="logo" src="../../../assets/img/bc_prize_author.png" alt="">
      <div :style="adminDivMouseover">
        平台管理员
        <img :style="adminDivMouseover" class="open" src="../../../assets/img/choose.svg" alt="">
      </div>
    </div>
    <list-radio class="languageRadio" v-if="isLanguageDivShow">
      <strong slot="title">默认配置语言</strong>
      <list-radio-item slot="itemList">
        <img src="../../../assets/img/China.png" alt="">
        简体中文
      </list-radio-item>
    </list-radio>
    <list-radio class="adminRadio" v-if="isAdminDivShow">
      <strong slot="title">账号设置</strong>
      <div slot="itemList">
        <div @click="toAdminData">
          <list-radio-item class="item">
            基本资料
          </list-radio-item>
        </div>
        <div @click="logout">
          <list-radio-item class="item">
            注销
          </list-radio-item>
        </div>
      </div>
    </list-radio>
    <div id="barrier" @click="barrier" v-if="isAdminDivShow||isLanguageDivShow">
    </div>
  </div>
</template>

<script>
  import ListRadioItem from "../../common/ListRadio/ListRadioItem";
  import ListRadio from "../../common/ListRadio/ListRadio";
  export default {
    name: "Header",
    components: {ListRadioItem, ListRadio},
    data(){
      return{
        isAdminDivMouseover:false,
        isLanguageDivMouseover:false,
        isAdminDivShow:false,
        isLanguageDivShow:false,
      }
    },
    computed: {
      adminDivMouseover(){
        return this.isAdminDivMouseover ? {} : {"opacity": 0.5}
      },
      languageDivMouseover(){
        return this.isLanguageDivMouseover ? {} : {"opacity": 0.5}
      }
    },
    methods: {
      languageMouseover(){
        this.isLanguageDivMouseover = true
      },
      languageMouseout(){
        this.isLanguageDivMouseover = false
      },
      adminMouseover(){
        this.isAdminDivMouseover = true
      },
      adminMouseout(){
        this.isAdminDivMouseover = false
      },
      languageDivShow(){
        this.isLanguageDivShow = !this.isLanguageDivShow;
        this.isAdminDivShow = false
      },
      adminDivShow(){
        this.isAdminDivShow = !this.isAdminDivShow;
        this.isLanguageDivShow = false
      },
      barrier(){
        this.isAdminDivShow = false;
        this.isLanguageDivShow = false
      },
      toAdminData(){
        console.log("aaa");
        let id = sessionStorage["adminId"]
        this.$router.push("/admin/data/"+id)
      },
      logout(){
        console.log("bbb");
        sessionStorage["adminId"] = null;
        sessionStorage["isLogin"] = false;
        sessionStorage["jwtToken"] = null;
        this.common.loginInfo.isLogin = false;
        this.common.loginInfo.jwtToken = null;
        this.$router.push("/login");
      }
    }
  }
</script>

<style scoped>
  #header{
    background-color: #fff;
    border-bottom: 1px solid rgba(165, 165, 165, 0.7);
    height: 55px;
    line-height: 55px;
    width: 100%;
    position: relative;
  }

  .china{
    margin-right: 6px;
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: middle;
  }

  #languageDiv{
    height: 55px;
    line-height: 55px;
    position: absolute;
    right: 200px;
    z-index: 11;
  }

  #adminDiv{
    height: 55px;
    line-height: 55px;
    position: absolute;
    right: 50px;
    z-index: 11;
  }

  .open{
    width: 10px;
    height: 10px;
    display: inline-block;
    vertical-align: middle;
    /*opacity: 0.7;*/
  }

  .logo{
    height: 35px;
    width: 35px;
    display: inline-block;
    vertical-align: middle;
    border-radius: 50px;
  }

  #adminDiv div{
    font-size: 0.875rem;
    margin-left: 10px;
    display: inline-block;
    /*opacity: 0.7;*/
    color: rgba(0, 0, 0, 0.6);
  }

  .languageRadio{
    position: absolute;
    top: 57px;
    right: 200px;
    z-index: 11;
    background-color: #fff;
  }

  .adminRadio{
    position: absolute;
    right: 50px;
    top: 57px;
    z-index: 11;
    background-color: #fff;
  }

  #barrier{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    background-color: #fff;
    opacity: 0;
    z-index: 9;
  }

  .item{
    z-index: 11;
  }
</style>
